import React from 'react';

function HomePage() {
  return (
    <main className="home-page">
      {/* Hero Section */}
      <section className="hero-section" id="home">
        <div className="container">
          <div className="hero-content">
            <h1>Welcome to HBFC Home Finance</h1>
            <h2>Your Dream Home is Just a Loan Away</h2>
            <p>We provide affordable home financing solutions tailored to your needs.</p>
            <button className="cta-button">Apply Now</button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section" id="about">
        <div className="container">
          <h2>About HBFC</h2>
          <p>HBFC is Pakistan's premier housing finance institution, established to provide affordable housing finance solutions to the people of Pakistan. With decades of experience, we have helped thousands of families achieve their dream of owning a home.</p>
        </div>
      </section>

      {/* Loan Products Section */}
      <section className="products-section" id="products">
        <div className="container">
          <h2>Our Loan Products</h2>
          <div className="product-cards">
            <div className="product-card">
              <h3>Home Purchase Loan</h3>
              <p>Finance for buying your dream home with competitive rates and flexible terms.</p>
              <ul>
                <li>Financing up to 85% of property value</li>
                <li>Tenure up to 25 years</li>
                <li>Competitive markup rates</li>
              </ul>
            </div>
            <div className="product-card">
              <h3>Home Construction Loan</h3>
              <p>Build your home exactly the way you want with our construction financing.</p>
              <ul>
                <li>Stage-wise disbursement</li>
                <li>Technical assistance</li>
                <li>Flexible payment options</li>
              </ul>
            </div>
            <div className="product-card">
              <h3>Home Renovation Loan</h3>
              <p>Give your existing home a new look with our renovation financing.</p>
              <ul>
                <li>Quick approval process</li>
                <li>Minimal documentation</li>
                <li>Affordable installments</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Calculator Section */}
      <section className="calculator-section" id="calculator">
        <div className="container">
          <h2>Loan Eligibility Calculator</h2>
          <p>Use our calculator to estimate your loan eligibility and monthly installments.</p>
          <div className="calculator-placeholder">
            <p>Calculator coming soon...</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section" id="contact">
        <div className="container">
          <h2>Contact Us</h2>
          <p>Have questions? Our team is here to help you.</p>
          <div className="contact-info">
            <div className="contact-form">
              <h3>Send us a message</h3>
              <form>
                <div className="form-group">
                  <input type="text" placeholder="Your Name" />
                </div>
                <div className="form-group">
                  <input type="email" placeholder="Your Email" />
                </div>
                <div className="form-group">
                  <textarea placeholder="Your Message"></textarea>
                </div>
                <button type="submit" className="submit-button">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default HomePage; 